// Import libraries
import { createFromIconfontCN } from '@ant-design/icons';

const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_1678533_b9usc76dl9o.js',
});

export default IconFont;
